/* eslint-disable camelcase */

import loadable from '@loadable/component';
import { NEW_SEARCH_INDEX_MARKETS } from './constants';

import searchPageQuery from './query.graphql';

const SearchPage = loadable(() =>
  import(/* webpackChunkName: "search" */ './components/results')
);

export const queryToVariables = ({
  search = '',
  offset = 0,
  sort = '',
  category_id = '',
  brand_id = '',
  lowest_price = '',
  user_rating = '',
  marketCode,
}) => {
  return {
    id: 'search',
    query: search,
    sort: sort.split(':')[0] || 'score',
    order: sort.split(':')[1] || 'desc',
    offset: parseInt(offset, 10),
    limit: 48,
    filters: [
      { id: 'category_id', selected: category_id.split(',').filter(Boolean) },
      { id: 'brand_id', selected: brand_id.split(',').filter(Boolean) },
      {
        id: 'lowest_price',
        from: parseInt(lowest_price.split(',')[0], 10) || undefined,
        to: parseInt(lowest_price.split(',')[1], 10) || undefined,
      },
      {
        id: 'user_rating',
        from: parseInt(user_rating.split(',')[0], 10) || undefined,
        to: parseInt(user_rating.split(',')[1], 10) || undefined,
      },
    ],
    productModes: ['product', 'raw'],
    newSearch: NEW_SEARCH_INDEX_MARKETS.includes(marketCode),
    categoryFilters: category_id.split(',').filter(Boolean),
    brandFilters: brand_id.split(',').filter(Boolean),
    getExperts: marketCode !== 'nz',
  };
};

SearchPage.variables = queryToVariables;

SearchPage.graphQL = searchPageQuery;

SearchPage.loadOrder = [{}];

SearchPage.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => ['query', 'sort', 'order', 'offset'].indexOf(key) > -1)
        .map(key => variables[key])
    : [];

  const filterVariables =
    variables && variables.filters
      ? variables.filters.map(filter => {
          switch (filter.id) {
            case 'category_id':
            case 'brand_id':
              return `${filter.id}:${filter.selected}`;
            case 'lowest_price':
            case 'user_rating':
              return `${filter.id}:${filter.from}:${filter.to}`;
            default:
              return filter.id;
          }
        })
      : [];

  return `${name}_${groupVariables.join('_')}_${filterVariables.join('_')}`;
};

export default SearchPage;
